import {match} from 'ts-pattern';

import {always, isNil} from 'ramda';

import {Nullish} from 'shared/web';

export type MazdaAmountAgreementState = 'agreed' | 'notAgreed' | 'unknown';

export const getMazdaAmountAgreementState = (
  requestedAmount: number | Nullish,
  agreedAmount: number | Nullish
): MazdaAmountAgreementState =>
  match({requestedAmount, agreedAmount})
    .when(
      ({requestedAmount: requested, agreedAmount: agreed}) => isNil(requested) || isNil(agreed),
      always<MazdaAmountAgreementState>('unknown')
    )
    .when(
      ({requestedAmount: requested, agreedAmount: agreed}) => (agreed ?? 0) >= (requested ?? 0),
      always<MazdaAmountAgreementState>('agreed')
    )
    .otherwise(always<MazdaAmountAgreementState>('notAgreed'));
